'use strict';

var AuthError = require('./AuthError.js');

class AuthWindowClosedError extends AuthError.AuthError {
    constructor(params) {
        const { message = "Child window for authentication was closed" } = params || {};
        super({ message });
    }
}

exports.AuthWindowClosedError = AuthWindowClosedError;
//# sourceMappingURL=AuthWindowClosedError.js.map
